/** Shared helper for capture panels — human-readable upload outcome. */
import type { MediaAsset } from "../domain/types";

type TranslateFn = (key: string, vars?: Record<string, string | number>) => string;

export function uploadStatusLabel(
  asset: MediaAsset | null | undefined,
  t: TranslateFn
): string {
  if (!asset) return "";
  if (asset.uploadStatus === "uploading") return t("capture.uploadStatus.uploading");
  if (asset.uploadStatus === "failed") return t("capture.uploadStatus.failed");
  if (asset.uploadStatus === "uploaded") {
    if (asset.uploadSource === "local-fallback") return t("capture.uploadStatus.savedLocally");
    if (asset.uploadSource === "cloud" || asset.publicUrl) return t("capture.uploadStatus.uploaded");
    return t("capture.uploadStatus.stored");
  }
  return asset.reviewStatus;
}

export function uploadUserMessage(
  asset: MediaAsset | null | undefined,
  t: TranslateFn
): string | null {
  if (!asset?.uploadError) return null;
  if (asset.uploadStatus === "failed") return asset.uploadError;
  if (asset.uploadSource === "local-fallback") {
    return t("capture.uploadStatus.localFallbackNote", { error: asset.uploadError });
  }
  return asset.uploadError;
}
